<template>
  <section
    class="merge-result-pipeline-card"
    :style="{ '--merge-result-area-border-color': mergeResultStatusColor }"
  >
    <div
      v-if="isMergeRequestPipelineCreationShown"
      class="merge-result-pipeline-card__create"
    >
      <div class="info">
        <b>{{ $t('merge_result_pipeline_none') }}</b>
      </div>
      <div class="actions">
        <gf-button
          v-if="mergeRequest.conflicts.length == 0"
          class="create-button"
          variant="primary"
          :text="$t('create_pipeline')"
          :disabled="isResultPipelineCreating"
          @click="runResultMergePipeline"
        />
        <gf-custom-tooltip
          v-else
          width="max-content"
        >
          <template #element>
            <gf-button
              class="create-button"
              variant="primary"
              :disabled="true"
              :text="$t('create_pipeline')"
            />
          </template>
          <template #content>
            <div class="tooltip-content">
              {{ $t('runMergePipelineMergeRequests') }}
            </div>
          </template>
        </gf-custom-tooltip>
      </div>
    </div>
    <div
      v-else-if="mergeRequest?.mergeResultsPipeline"
      class="merge-result-pipeline-card__status"
    >
      <ci-main-status
        v-if="mergeRequest?.mergeResultsPipeline?.status"
        class="status"
        :status="mergeRequest?.mergeResultsPipeline?.status"
      />
      <div class="info">
        <h6 class="title">
          <span>{{ $t('merge_result_pipeline') }}</span>
          <a :href="resultPipelineLink">#{{ mergeRequest?.mergeResultsPipeline?.localId }}</a>
        </h6>
        <div class="additional">
          <span>{{ $t('pipeline_start') }}</span>
          <a :href="resultPipelineCommitLink">
            <code>{{ mergeRequest?.mergeResultsPipeline?.commitHash?.slice(0, 7) }}</code>
          </a>
          <span v-if="mergeRequest?.mergeResultsPipeline?.finishedAt">
            {{ $moment(mergeRequest?.mergeResultsPipeline?.finishedAt).fromNow() }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import CiMainStatus from '@shared/modules/ci-cd/components/ci-main-status';
import GfCustomTooltip from '@shared/shared-components/shared/GfCustomTooltip';
import MergeRequestService from '@shared/modules/merge-request/merge-request.service';
import GfButton from '@/shared-modules/shared-components/shared/components/GfButton';
import MergeRequestMessages from '@/shared-modules/modules/merge-request/mergeRequestMessages';

export default {
  name: 'MergeResultPipelineCard',
  components: {
    CiMainStatus,
    GfButton,
    GfCustomTooltip
  },
  data() {
    return {
      isResultPipelineCreating: false
    };
  },
  computed: {
    mergeRequest() {
      return this.$store.getters.getSelectedMergeRequest;
    },
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    isMergeRequestPipelineCreationShown() {
      return (
        this.getActionAvailabilityFlag(ACTION_ENUM.EXECUTE_CI_CD) &&
        this.mergeRequest?.mergePipelineActionTypeSet?.includes('SHOW_KRS')
      );
    },
    mergeResultStatusColor() {
      return this.mergeRequest?.mergeResultsPipeline?.status?.hexColor
        ? `#${this.mergeRequest?.mergeResultsPipeline?.status?.hexColor}`
        : 'var(--border-color)';
    },
    resultPipelineLink() {
      return `/project/${this.mergeRequest?.targetProject?.ownerAlias}/${this.mergeRequest?.targetProject?.alias}/ci-cd/pipeline/${this.mergeRequest?.mergeResultsPipeline?.localId}`;
    },
    resultPipelineCommitLink() {
      return `/project/${this.mergeRequest?.targetProject?.ownerAlias}/${this.mergeRequest?.targetProject?.alias}/commit/${this.mergeRequest?.mergeResultsPipeline?.commitHash}`;
    }
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    runResultMergePipeline() {
      this.isResultPipelineCreating = true;
      MergeRequestService.runMergeResultPipeline(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      )
        .then(() => {
          this.isResultPipelineCreating = false;
        })
        .catch(() => {
          this.isResultPipelineCreating = false;
        });
    }
  },
  i18n: {
    messages: MergeRequestMessages
  }
};
</script>

<style lang="scss">
$this: '.merge-result-pipeline-card';

#{$this} {
  --merge-result-area-border-color: var(--border-color);

  padding: 16px;
  border: 1px solid var(--merge-result-area-border-color);
  border-radius: 6px;

  #{$this}__create {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    @include theme.max-sm {
      flex-direction: column;
    }

    & > .info {
      font-size: 16px;
      color: var(--text-muted);
    }
    & > .actions {
      white-space: nowrap;

      @include theme.max-sm {
        width: 100%;
      }

      & .create-button {
        @include theme.max-sm {
          width: 100%;
        }
      }

      & .tooltip-content {
        white-space: break-spaces;
        text-align: center;
      }
    }
  }
  #{$this}__status {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;

    & > .info {
      display: flex;
      flex-direction: column;
      gap: 8px;

      & > .title {
        margin-bottom: 0;
        display: flex;
        gap: 4px;
      }

      & > .additional {
        display: flex;
        gap: 4px;
        color: var(--text-muted);

        & code {
          max-height: 20px;
          padding: 1px 2px;
          font-size: 14px;
          color: var(--primary);
        }
      }
    }
  }
}
</style>
